// A small, illustrative embed used by the seed post to exercise component-MDX.
// It is intentionally static and makes no technical claims — just shows that a
// React component renders inline inside an article body.
const events = [
	{ event: 'deposit 2 ETH', debit: 'ETH (asset)', credit: 'Capital' },
	{ event: 'buy 1 ETH @ $3,000', debit: 'ETH (asset)', credit: 'USD (asset)' },
	{ event: 'sell 1 ETH @ $3,400', debit: 'USD (asset)', credit: 'ETH + Gain' },
]

export function LedgerDemo() {
	return (
		<div className="not-prose border-border my-6 overflow-x-auto rounded-lg border">
			<table className="w-full text-left text-sm">
				<thead className="bg-muted/50 text-muted-foreground">
					<tr>
						<th className="px-4 py-2 font-medium">On-chain event</th>
						<th className="px-4 py-2 font-medium">Debit</th>
						<th className="px-4 py-2 font-medium">Credit</th>
					</tr>
				</thead>
				<tbody>
					{events.map((row) => (
						<tr key={row.event} className="border-border border-t">
							<td className="px-4 py-2 font-mono text-xs">{row.event}</td>
							<td className="px-4 py-2">{row.debit}</td>
							<td className="px-4 py-2">{row.credit}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
